import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LangCtx } from "@/data/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Legacy from "@/components/Legacy";
import Products from "@/components/Products";
import Presence from "@/components/Presence";
import Manufacturing from "@/components/Manufacturing";
import Certifications from "@/components/Certifications";
import Enquiry from "@/components/Enquiry";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ProductPage from "@/components/ProductPage";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Products />
    <Legacy />
    <Presence />
    <Manufacturing />
    <Certifications />
    <Enquiry />
  </main>
);

export default function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("lf-lang") || "en");

  useEffect(() => {
    localStorage.setItem("lf-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <LangCtx.Provider value={{ lang, setLang }}>
      <BrowserRouter>
        <div className="bg-paper text-ink" data-testid="app-root">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductPage />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
        </div>
      </BrowserRouter>
    </LangCtx.Provider>
  );
}
